var MysaResponseLogColumnIdName = {
    ACTION_TIMESTAMP: 'Time',
    ACTIONS_COMMENT: 'Changes made',
    USER_EMAIL: ' Changed by'
};
var ValueAchievedColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    VALUE: 'Value',
    RESPONSE: 'Value Achieved Response',
    RESPONSE_CODE: 'Reason Code'
};
var BPAuthorizationColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    RESPONSE: 'BP Authorization Response',
    RESPONSE_CODE: 'Reason Code'
};
var CVRSolutionColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    VALUE: 'Value',
    CMR: 'CMR',
    SOLUTION: 'Solution',
    RESPONSE: 'CVR Solution response',
    RESPONSE_CODE: 'Reason Code'
};
var CVRNCColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    MYSA_DUP: 'MySa Dup',
    CD: 'CD',
    NC: 'NC',
    DR_GOE: 'DR GOE',
    INC_GOE: 'Incentives GOE',
    VALUE: 'Value',
    CMR: 'CMR',
    RESPONSE: 'CVR New Client response',
    RESPONSE_CODE: 'Reason Code'
};
var CVRSSAColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    MYSA_DUP: 'MySa Dup',
    SC_DUP: 'SC Dup',
    DR_GOE: 'DR GOE',
    INC_GOE: 'Incentives GOE',
    VALUE: 'Value',
    CMR: 'CMR',
    RESPONSE: 'CVR SSA response',
    RESPONSE_CODE: 'Reason Code'
};
var dupColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    MYSA_DUP: 'MySa Dup',
    DR_GOE: 'DR GOE',
    VALUE: 'Value',
    CMR: 'CMR',
    RESPONSE: 'Duplicate Check response',
    RESPONSE_CODE: 'Reason Code'
};
var BidColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    BPA: 'BPA',
    TA: 'TA',
    MYSA_DUP: 'MySa Dup',
    DR_GOE: 'DR GOE',
    VALUE: 'Value',
    CMR: 'CMR',
    RESPONSE: 'Special Bid response',
    RESPONSE_CODE: 'Reason Code'
};
var CDColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    CMR: 'CMR',
    CD: 'CD',
    RESPONSE: 'Customer Designation response',
    RESPONSE_CODE: 'Reason Code'
};
var IncGOEColumnIdName = {
    ID: 'ID',
    GEO: 'GEO',
    IMT: 'Market',
    COUNTRY: 'Country',
    EXCEPTION: 'Exception',
    CMR: 'CMR',
    INC_GOE: 'Incentives GOE',
    RESPONSE: 'Incentives GEO response',
    RESPONSE_CODE: 'Reason Code'
};
var MysaresponseViewController = (function () {
    function MysaresponseViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, config, settings) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.config = config;
        this.settings = settings;
        this.table = {};
        this.editMode = false;
        this.checkResults = [
            {
                name: 'BP Authorization',
                db: 'BP_AUTH',
                columnIdName: BPAuthorizationColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Value Achieved Configuration',
                db: 'VALUE_ACHIEVED',
                columnIdName: ValueAchievedColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'CVR Solution Configuration',
                db: 'CVR_SOLUTION',
                columnIdName: CVRSolutionColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Customer Designation Configuration',
                db: 'CD',
                columnIdName: CDColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'CVR New Client Configuration',
                db: 'CVR_NC',
                columnIdName: CVRNCColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Special Bid Configuration',
                db: 'SPEC_BID',
                columnIdName: BidColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'CVR SSA Configuration',
                db: 'CVR_SSA',
                columnIdName: CVRSSAColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Incentives GOE Configuration',
                db: 'INC_GOE',
                columnIdName: IncGOEColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
            {
                name: 'Duplicate Found Configuration',
                db: 'DUP',
                columnIdName: dupColumnIdName,
                columnLogIdName: MysaResponseLogColumnIdName
            },
        ];
        this.table.headers = [{
                'Main Status': '_link',
                'Description': 'desc'
            }];
    }
    MysaresponseViewController.prototype.updateCheckData = function (check) {
        var _this = this;
        this.editMode = true;
        this.checkResults.forEach(function (el) {
            if (check === el.name) {
                _this.selectedCheckData = el;
            }
        });
    };
    MysaresponseViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket',
        '$scope', 'admin', 'config', 'settings'];
    return MysaresponseViewController;
}());
var MysaresponseViewComponent = (function () {
    function MysaresponseViewComponent() {
        this.templateUrl = 'mysaresponse-view.html';
        this.controllerAs = 'vm';
        this.controller = MysaresponseViewController;
    }
    return MysaresponseViewComponent;
}());
angular
    .module('application')
    .component('viewMysaresponseSection', new MysaresponseViewComponent());

//# sourceMappingURL=mysaresponse.view.component.js.map
